<section>
  <nav class="navbar">
    <div class="container level">
      <div class="level-item">
        <div class="flex flex-start">
          <h1 class="is-size-3 has-text-weight-semibold">Loggtjänst</h1>
        </div>
      </div>
    </div>
  </nav>

  <section class="container content-container">
    <section class="main">
      <section class="main-content">
        <div class="column has-text-centered">
          <p class="is-size-5 has-text-weight-semibold mt-6 mb-4">
            Du har loggat ut från Loggtjänst.
          </p>
          <a (click)="redirect()">Återgå till Loggtjänst</a>
        </div>
      </section>
    </section>
  </section>
</section>
